import { ReactElement } from "react"
// import { motion } from 'framer-motion';
// import Loader from '../../../components/loader/Loader';

export interface TabsProps {
    layoutID: string
    onFilterChange?: (event: string) => void
    filterColor?: string
    hoverTextColor?: boolean
    selectedFilter?: any
    filterType: { label: string; value: string }[]
    disabled?: boolean
    setSelectedFilter?: any
    loader?: boolean
}

function Tabs({
    layoutID,
    onFilterChange = (): void => {},
    filterColor = "bg-gradient-primary-blue",
    hoverTextColor,
    selectedFilter,
    filterType,
    disabled,
    setSelectedFilter,
    loader = false,
}: TabsProps): ReactElement {
    return (
        <div
            className={`relative flex flex-col screen470:flex-row justify-between items-center rounded-xl
  orange-gradient-border 
  w-full lg:w-1/2 xl:w-5/12 2xl:w-1/3 p-2 text-white ml-auto lg:ml-0 h-fit`}
        >
            {loader && (
                <div className="absolute inset-0 flex justify-center items-center z-40 bg-white bg-opacity-50 w-full h-full rounded-md">
                    {/* <Loader className="w-6 h-6 !top-1/2 !left-1/2 transform -translate-x-1/2 -translate-y-1/2" /> */}
                </div>
            )}
            {filterType.map(
                (t): ReactElement => (
                    <button
                        key={t.value}
                        disabled={disabled}
                        onClick={(): void => {
                            onFilterChange(t.value)
                            if (setSelectedFilter) {
                                setSelectedFilter(t.value)
                            }
                        }}
                        className={`relative flex w-full md:w-auto items-center justify-center px-6 py-1 rounded-md cursor-pointer text-sm font-medium ${
                            t.value === selectedFilter && !loader
                                ? `text-white primary-orange`
                                : `hover:${
                                      hoverTextColor === true
                                          ? "text-primary"
                                          : "text-[#FF2727]"
                                  }`
                        }`}
                    >
                        <span className="relative z-10">{t.label}</span>

                        {t.value === selectedFilter && (
                            <div
                                key={layoutID}
                                className={`absolute inset-0 ${
                                    loader ? "" : filterColor
                                } rounded-md`}
                                // initial={{ opacity: 0 }}
                                // animate={{ opacity: 1 }}
                                // exit={{ opacity: 0 }}
                                // transition={{
                                //     type: 'spring',
                                //     bounce: 0.2,
                                //     duration: 0.6,
                                // }}
                            />
                        )}
                    </button>
                )
            )}
        </div>
    )
}

export default Tabs
